import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { queryRelevanceTestDefinitions, QUERY_KEY } from 'src/queries/queryRelevanceTestDefinitions';

type TestDefinitions = Models.PageResult<Models.IngestConfigApi.RelevanceTests.RelevanceTestDefinition>;
type QueryKey = App.RelevanceTestDefinitions.QueryKey;

export const useQueryRelevanceTestDefinitions = (
    accessToken: string | undefined | false,
    search: App.RelevanceTestDefinitions.PagedSearch,
    options?: UseQueryOptions<TestDefinitions, Error, TestDefinitions, App.RelevanceTestDefinitions.QueryKey>,
): UseQueryResult<TestDefinitions, Error> => useQuery<TestDefinitions, Error, TestDefinitions, QueryKey>(
    [QUERY_KEY, accessToken, search],
    queryRelevanceTestDefinitions,
    options,
);
